// extracted by mini-css-extract-plugin
module.exports = {"wizardContentSizeProgress":"_3HTlZeEn","icon":"_2_0gYuL7"};